// ===========================================
// HEALTH CHIPS — named flags, never a score
// ===========================================
// Small pills on cards and in the panel. Each carries a plain-language
// tooltip with the numbers behind it (hover the chip). A flag either holds
// on the records or it isn't shown — no composite "health score" pretending
// precision we don't have.

import clsx from 'clsx';
import type { HealthFlag } from './insights';

const TONE: Record<HealthFlag['tone'], string> = {
  red: 'bg-red-50 text-red-700',
  amber: 'bg-amber-50 text-amber-700',
  emerald: 'bg-emerald-50 text-emerald-700',
};

export default function HealthChips({ flags, max, className }: { flags: HealthFlag[]; max?: number; className?: string }) {
  if (flags.length === 0) return null;
  const shown = max ? flags.slice(0, max) : flags;
  const hidden = flags.length - shown.length;
  return (
    <div className={clsx('flex flex-wrap items-center gap-1', className)}>
      {shown.map((f) => (
        <span key={f.id} title={f.tip} className={clsx('px-1.5 py-0.5 rounded text-[10px] font-medium cursor-default', TONE[f.tone])}>
          {f.label}
        </span>
      ))}
      {hidden > 0 && (
        <span className="px-1.5 py-0.5 rounded text-[10px] font-medium bg-slate-100 text-slate-500 cursor-default"
          title={flags.slice(shown.length).map((f) => f.label).join(' · ')}>
          +{hidden}
        </span>
      )}
    </div>
  );
}
